module.exports = __webpack_public_path__ + "img/mf4.220a0f5b.png";